var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyIban = function SvgCopyIban(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 416 480",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 416,
    y: 64,
    rx: 48,
    ry: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 48v320c-.08 26.48-21.52 47.92-48 48h-16V112c0-44.18-35.82-80-80-80H98.88C105.64 12.87 123.71.06 144 0h224c26.48.08 47.92 21.52 48 48"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyIban);
export default ForwardRef;